import React from 'react';
import { motion } from 'framer-motion';

interface SearchButtonProps {
  onClick: () => void;
}

const SearchButton: React.FC<SearchButtonProps> = ({ onClick }) => {
  return (
    <motion.button
      onClick={onClick}
      // The search button lives on the ink sidebar, so it is tinted for a dark ground.
      className="relative rounded p-1.5 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white"
      whileTap={{ scale: 0.95 }}
      aria-label="Search (⌘K)"
      title="Search (⌘K)"
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
    </motion.button>
  );
};

export default SearchButton;
